// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingPriceProductResponse

export type WidgetBookingPriceProductApiResponse = {
	name: string;
	quantity: number;
	unitPrice: number;
	total: number;
};

export type WidgetBookingPriceProduct = {
	name: string;
	quantity: number;
	unitPrice: number;
	total: number;
};

export function hydrateWidgetBookingPriceProduct(data: WidgetBookingPriceProductApiResponse): WidgetBookingPriceProduct {
	return { ...data };
}